import { render } from "./VoterOrganizer.vue?vue&type=template&id=3e276654&scoped=true"
import script from "./VoterOrganizer.vue?vue&type=script&lang=js"
export * from "./VoterOrganizer.vue?vue&type=script&lang=js"

import "./VoterOrganizer.vue?vue&type=style&index=0&id=3e276654&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e276654"]])

export default __exports__